import "./ExamListing.css";
import React, { Fragment, useContext } from "react";
import { Link } from "react-router-dom";
import ExamListingViewModel from "./ExamListingViewModel";
import ActionConfirmation from "../../../../../Components/ActionConfirmation/ActionConfirmation";
import { PulseLoader } from "react-spinners";

const ExamListing = () => {
  const {
    DeleteDialog,
    handleOpenDeleteDialog,
    handleCloseDeleteDialog,
    ClassID,
    CourseID,
    ExamsArray,
    navigate,
    IsLoading,
    AuthUser,
  } = ExamListingViewModel();

  return (
    <Fragment>
      {/* Page Wrapper */}
      <div className="page-wrapper exam-listing-page">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Exams Listing</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="#">Dashboard</a>
                  </li>
                  <li className="breadcrumb-item active">Exams Listing</li>
                </ul>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          <div className="row">
            <div className="col-sm-12">
              <div className="card card-table">
                <div className="card-body">
                  {/* Page Header */}
                  <div className="page-header">
                    <div className="row align-items-center">
                      <div className="col">
                        <h3 className="page-title">Exams Listing</h3>
                      </div>
                      <div className="col-auto text-end float-end ms-auto download-grp">
                        {(AuthUser?.UserType === "admin" ||
                          AuthUser?.UserType === "teacher") && (
                          <Link
                            to={`/user/${AuthUser?.UserType}/classes/${ClassID}/courses/${CourseID}/exams/add`}
                            className="btn btn-primary"
                          >
                            <i className="fas fa-plus" />
                          </Link>
                        )}
                      </div>
                    </div>
                  </div>
                  {/* /Page Header */}
                  {IsLoading ? (
                    <PulseLoader
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      color="#3D5EE1"
                      size={16}
                    />
                  ) : (
                    <div className="table-responsive">
                      <table className="table border-0 star-student table-hover table-center mb-0 datatable table-striped">
                        <thead className="student-thread">
                          <tr>
                            <th>Exam Name</th>
                            <th>Description</th>
                            <th>Total Marks</th>
                            <th>Start Time</th>
                            <th>End Time</th>
                            <th>Date</th>
                            <th className="text-end">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {ExamsArray &&
                            ExamsArray.map((item, index) => {
                              return (
                                <tr key={index}>
                                  <td>{item?.ExamName}</td>
                                  <td>{item?.ExamDescription}</td>
                                  <td>{item?.ExamTotalMarks}</td>
                                  <td>{item?.ExamStartTime}</td>
                                  <td>{item?.ExamEndTime}</td>
                                  <td>{item?.ExamDate}</td>
                                  <td className="text-end">
                                    <div className="actions">
                                      {/* <Link className="btn btn-sm bg-success-light me-2">
                                      <i className="fa-solid fa-file"></i>
                                    </Link> */}
                                      {item?.ResultID ? (
                                        <button
                                          onClick={() => {
                                            navigate(
                                              `/user/${AuthUser?.UserType}/classes/${ClassID}/courses/${CourseID}/exams/${item?.id}/result/${item?.ResultID}`
                                            );
                                          }}
                                          className="btn btn-sm bg-success-light me-2 results-btn"
                                        >
                                          View Result
                                        </button>
                                      ) : AuthUser?.UserType === "admin" ||
                                        AuthUser?.UserType === "teacher" ? (
                                        <button
                                          onClick={() => {
                                            navigate(
                                              `/user/${AuthUser?.UserType}/classes/${ClassID}/courses/${CourseID}/exams/${item?.id}/result/add`
                                            );
                                          }}
                                          className="btn btn-sm bg-success-light me-2 results-btn"
                                        >
                                          Upload Result
                                        </button>
                                      ) : (
                                        (AuthUser?.UserType === "student" ||
                                          AuthUser?.UserType === "parent") && (
                                          <button className="btn btn-sm bg-success-light me-2 results-btn">
                                            Result Is Not Uploaded
                                          </button>
                                        )
                                      )}

                                      {(AuthUser?.UserType === "admin" ||
                                        AuthUser?.UserType === "teacher") && (
                                        <>
                                          <Link
                                            onClick={() => {
                                              handleOpenDeleteDialog(item?.id);
                                            }}
                                            className="btn btn-sm bg-success-light me-2"
                                          >
                                            <i className="fa-regular fa-trash-can"></i>
                                          </Link>
                                          <Link
                                            to={`/user/${AuthUser?.UserType}/classes/${ClassID}/courses/${CourseID}/exams/update/${item?.id}`}
                                            className="btn btn-sm bg-danger-light"
                                          >
                                            <i className="fa-regular fa-pen-to-square"></i>
                                          </Link>
                                        </>
                                      )}
                                    </div>
                                  </td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}

      <ActionConfirmation
        title={"Delete Confirmation"}
        description={"Are you sure you want to delete this exam?"}
        openDialog={DeleteDialog}
        handleCloseDialog={handleCloseDeleteDialog}
      />
    </Fragment>
  );
};

export default ExamListing;
